// 共通インポートファイル
import { resizeWithCrop } from "./resizeWithCrop";
import { resizeWithRatio } from "./resizeWithRatio";

export const resizeImage = (file, targetWidth, targetHeight, mode, cropPosition = "center") => {
    if (mode === "crop") {
        return resizeWithCrop(file, targetWidth, targetHeight, cropPosition);
    } else {
        return resizeWithRatio(file, targetWidth, targetHeight);
    }
};
